export default __webpack_public_path__ + "static/share-256a358b0d07bad91cee02a019d245dc.jpg";